// extracted by mini-css-extract-plugin
export default {"overlay":"Orientation_overlay__8z6Qs","overlay-content":"Orientation_overlay-content__p65HW","show":"Orientation_show__lkTKA","hide":"Orientation_hide__BXl4t"};